module.exports = __webpack_public_path__ + "media/old_images/intro-iphone-tyresta-51a9bde1.png";